import UserOverviewSubPage from "./user-owerview-sub-page";


const SubPage = {
    OverView: UserOverviewSubPage,
};

export default SubPage;
